import {Fragment, useContext} from "react";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {NewDispatchOrderForm} from "./NewDispatchOrderForm";

export let CreateDispatchOrderPage = function () {
    const context = useContext(GlobalContext);
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createDispatchOrder,
        'dispatch order',
        () => context.navigator.goBack()
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <NewDispatchOrderForm
                save={modelCreateEngine.createModel}
                cancel={() => context.navigator.goBack()}
                isNew={true}
            />
        </Fragment>
    );
};
